import ngTranslate from 'angular-translate';
import assign from 'lodash/assign';

import template from './appBadge.html';
import './appBadge.scss';

export const AppBadgeModule = angular
    .module('app.components.appBadges.appBadge', [
        ngTranslate
    ]).component('appBadge', {
        template,
        controller: class AppBadgeController {
            constructor($translate, $attrs) {
                'ngInject';

                assign(this, {
                    icon: '',
                    color: '',
                    translation: '',
                    $translate,
                    $attrs
                });
            }

            $onInit() {
                this.$attrs.$observe('app', (value) => {
                    switch (value) {
                        case 'products':
                            this.setScope('TITLETAG.PRODUCTS', 'local_offer', '#0FB3CC');
                            break;
                        case 'orders':
                            this.setScope('TITLETAG.ORDERS', 'shopping_cart', '#3EC671');
                            break;
                        case 'categories':
                            this.setScope('TITLETAG.CATEGORIES', 'list', '#1E66C3');
                            break;
                        case 'pages':
                            this.setScope('TITLETAG.PAGES', 'insert_drive_file', '#C45898');
                            break;
                        case 'customers':
                            this.setScope('TITLETAG.CUSTOMERS', 'people', '#684BB6');
                            break;
                        case 'settings':
                            this.setScope('TITLETAG.SETTINGS', 'settings', '#FF8955');
                            break;
                        case 'custom':
                            this.setScope('TITLETAG.MORE_COUNT', '', 'rgba(0,0,0,0.30)', this.$attrs.count);
                            break;
                        default:
                    }
                });
            }

            setScope(translation, icon, color, count) {
                this.icon = icon;
                this.color = color;
                this.$translate(translation, { COUNT: count }).then((message) => {
                    this.translation = message;
                });
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/appBadges/appBadge.component.js